import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { InView } from 'react-intersection-observer'
import { ErrorBoundary } from '@sainsburys-tech/bolt'

import AddToTrolleyModal from '../../components/AddToTrolleyModal/AddToTrolleyModal'
import AddToTrolleyStickyContainer from '../../components/AddToTrolleySticky/AddToTrolleyStickyContainer'
import AddToTrolleyButtonContainer from '../../components/AddToTrolleyButton/AddToTrolleyButtonContainer'
import { useBrandConfigContext } from '../../providers/BrandConfigContext/BrandConfigContext'

const AddToTrolleySection = ({ addToTrolleyButtonOptions, addToTrolleyModalOptions, addToTrolleyStickyOptions }) => {
  const [isMainATTInView, setIsMainATTInView] = useState(true)
  const { STICKY_BAR } = useBrandConfigContext()
  return (
    <>
      <ErrorBoundary>
        <AddToTrolleyModal {...addToTrolleyModalOptions} />
      </ErrorBoundary>

      {STICKY_BAR && (
        <ErrorBoundary>
          <AddToTrolleyStickyContainer inView={isMainATTInView} {...addToTrolleyStickyOptions} />
        </ErrorBoundary>
      )}
      <ErrorBoundary>
        <InView as='div' onChange={inView => setIsMainATTInView(inView)} threshold={1} rootMargin='0px 0px 3000px 0px'>
          <AddToTrolleyButtonContainer {...addToTrolleyButtonOptions} />
        </InView>
      </ErrorBoundary>
    </>
  )
}

AddToTrolleySection.propTypes = {
  addToTrolleyButtonOptions: PropTypes.object.isRequired,
  addToTrolleyModalOptions: PropTypes.object.isRequired,
  addToTrolleyStickyOptions: PropTypes.object.isRequired
}

export default AddToTrolleySection
